/**
 * @generated SignedSource<<66aac7b2fb6f23a6e7de96432d0d230e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type YesNoBlank = "blank" | "no" | "yes";
export type businessSameIndustryQuery$variables = {
  bmanTin?: string | null | undefined;
  refundHistoryId: string;
};
export type businessSameIndustryQuery$data = {
  readonly getSurveyBusinessAnswer: {
    readonly businessAnswer: ReadonlyArray<{
      readonly hasPreviousBusinessInSameIndustry: YesNoBlank | null | undefined;
    }> | null | undefined;
    readonly result: boolean;
  };
};
export type businessSameIndustryQuery = {
  response: businessSameIndustryQuery$data;
  variables: businessSameIndustryQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "bmanTin"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "refundHistoryId"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "bmanTin",
        "variableName": "bmanTin"
      },
      {
        "kind": "Variable",
        "name": "refundHistoryId",
        "variableName": "refundHistoryId"
      }
    ],
    "concreteType": "SurveyBusinessAnswerOutput",
    "kind": "LinkedField",
    "name": "getSurveyBusinessAnswer",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "result",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "SurveyBusinessAnswer",
        "kind": "LinkedField",
        "name": "businessAnswer",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasPreviousBusinessInSameIndustry",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "businessSameIndustryQuery",
    "selections": (v2/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "businessSameIndustryQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "b8a83b32b73523ce5092ffd2f6bec4b6",
    "id": null,
    "metadata": {},
    "name": "businessSameIndustryQuery",
    "operationKind": "query",
    "text": "query businessSameIndustryQuery(\n  $refundHistoryId: String!\n  $bmanTin: String\n) {\n  getSurveyBusinessAnswer(refundHistoryId: $refundHistoryId, bmanTin: $bmanTin) {\n    result\n    businessAnswer {\n      hasPreviousBusinessInSameIndustry\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "f000898e682ec9c9c69cc6a54414541c";

export default node;
